export const cardDetails = {
  cardDigitCount: 16,
  cvcDigitCount: 3,
  americanExpressDigitCount: 4,
};
